(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["about-seven"]) return;
  try {
    



  $(document).ready(function() {

    //Sort random function
    function random(owlSelector){
      owlSelector.children().sort(function(){
        return Math.round(Math.random()) - 0.5;
      }).each(function(){
        $(this).appendTo(owlSelector);
      });
    }

    $("#test-car").owlCarousel({
      navigation: true,
      items : 1,
      navigationText: [
        "<i class='fa fa-angle-left '></i>",
        "<i class='fa fa-angle-right icon-white'></i>"
      ],
      //Call beforeInit callback, elem parameter point to $("#owl-demo")
      beforeInit : function(elem){
        random(elem);
      }

    });

  });






  $(document).ready(function() {

    //Sort random function
    function random(owlSelector){
      owlSelector.children().sort(function(){
        return Math.round(Math.random()) - 0.5;
      }).each(function(){
        $(this).appendTo(owlSelector);
      });
    }

    $("#img-car").owlCarousel({
      navigation: true,
      items : 1,
      navigationText: [
        "<i class='fa fa-chevron-left '></i>",
        "<i class='fa fa-chevron-right'></i>"
      ],
      //Call beforeInit callback, elem parameter point to $("#owl-demo")
      beforeInit : function(elem){
        random(elem);
      }

    });

  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutvedafour"]) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 1,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});







$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#client-car").owlCarousel({
navigation: true,
items : 6,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clientsection-five"] && !window.DesignMode) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 4,
pagination:true,
paginationNumbers:false,
navigation:false,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clientsection-six"] && !window.DesignMode) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 4,
pagination:true,
paginationNumbers:false,
navigation:true,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newaboutuspage-1"]) return;
  try {
    



$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#test-car").owlCarousel({
navigation: true,
items : 1,
pagination:false,


loop:true,
margin:10,
navigationText: [
"<i class='fa fa-chevron-left '></i>",
"<i class='fa fa-chevron-right'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});






$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
loop:true,
margin:10,
rtl:true,
items : 1,
pagination:true,
paginationNumbers:false,
navigationText: [
"<i class='fa fa-chevron-left '></i>",
"<i class='fa fa-chevron-right'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});








$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#client_car").owlCarousel({
navigation: false,
items : 6,
rtl:true,
pagination:true,
paginationNumbers:false,
navigationText: [
"<i class='fa fa-chevron-left '></i>",
"<i class='fa fa-chevron-right'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonail-twenty"]) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 1,
pagination:true,
paginationNumbers:false,
navigation:false,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-nineteen"]) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 2,
pagination:false,
paginationNumbers:false,
navigation:true,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-seven"]) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 2,
pagination:true,
paginationNumbers:false,
navigation:true,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-seventeen"]) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 1,
pagination:false,
paginationNumbers:false,
navigation:true,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-six"]) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 1,
pagination:true,
paginationNumbers:false,
navigation:false,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-thirteen"]) return;
  try {
    


$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#testimonial-car").owlCarousel({
navigation: true,
items : 4,
pagination:true,
paginationNumbers:false,
navigation:false,
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});






  } catch(e) { console.error(e); }
})();

})();
